import {
  PrimaryLightTextColor,
  PrimaryTextColor,
  boldFont,
  getRelativeFontSize,
  heading,
  mediumFont,
  primaryGrayBg,
  primaryLightGray,
  regularFont,
  subHeading,
} from "../../utils/styles";

const SalarySlipStyles = {
  salaryWrapper: {
    padding: "20px ",
  },

  headerWrapper: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  buttonWrapper: {
    display: "flex",
    flexDirection: "column",

    gap: "20px",
    "& button": {
      width: "100%",
      border: "2px solid",
      borderColor: primaryGrayBg,
    },
  },

  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "40px",
    ...regularFont,
    fontSize: getRelativeFontSize(0),
    color: " #3D3E58",
    background: "none",
    textTransform: "capitalize",
    "&:hover": {
      background: "none",
    },
    "& img": {
      width: "80%",
      height: "auto",
    },
  },

  customBtn: {
    width: "100%",
    border: "2px solid red",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  SalarySlipWrapper: {
    padding: "0 20px",
  },

  pageHeader: {
    marginTop: "15pxs",
  },
  pageHeading: {
    ...heading,
  },
  pageSubHeading: {
    ...subHeading,
  },

  headerLeft: {},
  headerRight: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    width: "100%",
    "& button": {
      "&:hover": {
        background: "none",
      },
    },
  },
  topSection: {
    padding: "0 20px",
  },

  pageTitle: {
    fontSize: getRelativeFontSize(10),
    ...boldFont,
  },
  autocomplateStyle: {
    width: "100%",
    background: "#fffff",
    "& .MuiInputBase-input": {
      color: PrimaryTextColor,
      ...regularFont,
      fontSize: getRelativeFontSize(2),
      "&::placeholder": {
        ...regularFont,
        fontSize: getRelativeFontSize(-1),
        color: PrimaryLightTextColor,
      },
    },
    "&  .MuiOutlinedInput-root": {
      padding: "4px 9px",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
      "&.Mui-focused fieldset": {
        borderColor: "#E7E7EA",
      },
      "&:hover fieldset": {
        borderColor: "#E7E7EA",
      },
    },
    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
      borderColor: "#E7E7EA",
    },
  },

  downloadSalarySlipWrapper: {
    border: "1px solid #EFF4FA ",
    marginTop: "20px",
    padding: "15px",
  },
  dowmlordSlipHeader: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "space-between",
  },

  addStyle: {
    ...regularFont,
    fontSize: getRelativeFontSize(-2),
    color: PrimaryTextColor,
  },

  salarySlipContent: {},

  idStyles: {
    ...mediumFont,
    fontSize: getRelativeFontSize(-2),
    color: PrimaryTextColor,
    "& span": {
      ...regularFont,
    },
  },
  nameStyle: {
    ...boldFont,
    fontSize: getRelativeFontSize(4),
    color: PrimaryTextColor,
  },
  dipatmentStyle: {
    ...mediumFont,
    fontSize: getRelativeFontSize(-2),
    color: PrimaryTextColor,
    "& span": {
      ...regularFont,
    },
  },
  pfStyle: {
    ...mediumFont,
    fontSize: getRelativeFontSize(-2),
    color: PrimaryTextColor,
    ...boldFont,
    display : "flex",
    "& span": {
      ...regularFont,
    },
  },

  spanLeft  :{
  width  :"100px"
  },

  dateStyle: {
    fontSize: getRelativeFontSize(4),
    ...boldFont,
    color: PrimaryTextColor,
    marginBottom  :"20px"
  },

  detailsSection : {
    borderTop : "1px solid #333",
    paddingbottom : "50px",
    borderBottom : "1px solid #333"
  },

  personInfo: {
    width: "100%",
    display: "flex",
    alignItems: "end",
    justifyContent: "space-between",
    paddingBottom  :"20px"
  },
  personInfoLeft: {},
  personInfoCenter: {},
  personInfoRight: {},
  infoBlocks: {
    marginTop: "20px",
  },

  listItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "15px",
    borderBottom: "1px solid #EFF4FA",
    paddingBottom: "15px",
  },

  itemText: {
    fontSize: getRelativeFontSize(-2),
    ...regularFont,
  },

  title: {
    ...boldFont,
  },

  salaryInfoBottom : {
    
  }
};

export default SalarySlipStyles;
